import { format, parse } from 'date-fns'

// test: jest src/utils/value-objects/__tests__/Datetime.test.js
export default class Datetime {
  fromDatetime(datetime) {
    const [date, time] = datetime.split(' ')
    this.date = date
    this.time = this._normalizeToTimewithSeconds(time)
    return this
  }

  fromTime(time) {
    this.time = this._normalizeToTimewithSeconds(time)
    return this
  }

  _normalizeToTimewithSeconds(timeString) {
    // Handle both formats: with seconds (HH:mm:ss) and without seconds (HH:mm)
    const inputPattern = timeString.includes(':') && timeString.split(':').length === 3 ? 'HH:mm:ss' : 'HH:mm';
    return format(parse(timeString, inputPattern, new Date()), 'HH:mm:ss')
  }

  toDatetimeNoSecond() {
    return format(new Date(`${this.date} ${this.time}`), 'yyyy-MM-dd HH:mm')
  }

  toTimeNoSecond() {
    return format(parse(this.time, 'HH:mm:ss', new Date()), 'HH:mm')
  }
}
